export default [
    '$rootScope',
    '$sce',
    function trustAsHtmlFacade($rootScope, $sce) {
        $rootScope.trustAsHtml = function trustAsHtml(string) {
            return $sce.trustAsHtml(string);
        };
    }
];
